import ModalDrag from '@/pages/components/ModaDrag/ModalDrag'
import { Button, Col, Input, message, Pagination, Row, Table } from 'antd'
import React, { useEffect, useReducer, useRef, useState } from 'react'
import GlobalCss from '@/global.module.less'
import css from './add-dataset-to-task.module.less'
import { sendHttpPostRequest } from '@/api/http-request'
import SearchInput from '@/pages/components/SearchInput/SearchInput'

function AddDatasetToTaskModal(props: any) {
  const { open, setOpen, actionCallback, actionDataset } = props
  const query = useRef('')
  const page = useRef(1)
  const pageSize = useRef(10)
  const [total, setTotal] = useState(0)
  const [datasource, setDatasource] = useState([])
  const [rowSelectedKeys, setRowSelectedKeys] = useState([])

  const onOk = () => {
    let data = {
      dataset_id: actionDataset.id + 0,
      exercise_id_list: JSON.stringify(rowSelectedKeys),
    }

    sendHttpPostRequest(
      'dataset/api/oam_mount_public_dataset_to_exercises/',
      data,
      (res) => {
        if (res.code == 0) {
          message.success('挂载成功~')
          setRowSelectedKeys([])
          query.current = ''
          page.current = 1
        } else {
          message.error(res.message)
        }
      }
    )

    setOpen(false)
  }

  const onCancel = () => {
    setRowSelectedKeys([])
    setOpen(false)
    query.current = ''
    page.current = 1
  }

  const getTaskList = () => {
    let data = {
      query: query.current,
      page: page.current,
      pagesize: pageSize.current,
      query_type: '1',
    }
    sendHttpPostRequest('exercise/api/oam_query_task_list', data, (res) => {
      if (res.code == 0) {
        setDatasource(res.exercise_list)
        setTotal(res.total_sum)
      }
    })
  }

  useEffect(() => {
    getTaskList()
    return () => {}
  }, [])

  const tableRowSelection = {
    selectedRowKeys: rowSelectedKeys,
    getCheckboxProps: (record: any) => ({
      disabled: record.mounted_dataset_id_list.some(
        (item) => actionDataset?.id == item
      ),
    }),
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setRowSelectedKeys(selectedRowKeys)
    },
  }
  const onPageChange = (np, nps) => {
    page.current = np
    pageSize.current = nps
    getTaskList()
  }

  const cols = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '80px',
    },
    {
      title: '任务名称',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
    },
    {
      title: '备注',
      dataIndex: 'remarks',
      key: 'remarks',
      ellipsis: true,
    },
  ]

  const AddDatasetToTaskModalContent = (
    <div>
      <Row align={'middle'} justify={'end'} style={{ marginBottom: '20px' }}>
        <Col>
          <SearchInput
            placeholder="搜索任务"
            width={224}
            onChange={(e) => {
              query.current = e.target.value
            }}
            onSearch={() => {
              page.current = 1
              getTaskList()
            }}
          />
        </Col>
      </Row>
      <div className={GlobalCss.tableWrapper}>
        <Table
          dataSource={datasource}
          columns={cols}
          pagination={false}
          rowKey={(r) => r.id}
          rowSelection={tableRowSelection}
        />
      </div>
      <div className={GlobalCss.pagination}></div>
    </div>
  )

  return (
    <ModalDrag
      width={720}
      modalTitle={'添加到任务'}
      modalContent={AddDatasetToTaskModalContent}
      open={open}
      onCancel={() => setOpen(false)}
      footer={
        <Row align={'middle'} justify={'space-between'}>
          <Col>
            {' '}
            <Pagination
              current={page.current}
              pageSize={pageSize.current}
              total={total}
              onChange={onPageChange}
              hideOnSinglePage
              showSizeChanger={false}
            />
          </Col>
          <Col className={GlobalCss.ColFlex} style={{ gap: '10px' }}>
            <Button type="default" onClick={onCancel}>
              取消
            </Button>
            <Button onClick={onOk} type="primary" style={{ margin: '0px' }}>
              确定
            </Button>
          </Col>
        </Row>
      }
    />
  )
}

export default AddDatasetToTaskModal
